const SecurityModals = {
    LoadExtension: 'LoadExtension',
    Fetch: 'Fetch',
    OpenWindow: 'OpenWindow',
    Redirect: 'Redirect',
    RecordAudio: 'RecordAudio',
    RecordVideo: 'RecordVideo',
    ReadClipboard: 'ReadClipboard',
    Notify: 'Notify'
};

export default SecurityModals;
